/**
 * Hook to check if the app is running in Electron desktop environment
 * Returns true if running in Electron, false if running in web browser
 */
export const useIsElectron = (): boolean => {
  return typeof window !== 'undefined' && !!window.electronAPI;
};

/**
 * Utility function to check if the app is running in Electron
 * Can be used outside of React components
 */
export const isElectronApp = (): boolean => {
  return typeof window !== 'undefined' && !!window.electronAPI;
};

export default useIsElectron;
